module.exports = __webpack_public_path__ + "img/emailEle.b3521d03.svg";